/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { AngularFireDatabase, PathReference } from '@angular/fire/compat/database';
import { IApplicationWideMessage } from 'src/app/app-data/models/ApplicationWideMessage';
import { fancyFirebaseGetters, masterFancyFirebaseReferencer } from '@touchplan/fancy-referencer';
import firebase from 'firebase/compat/app';

@Injectable({
	providedIn: 'root',
})
export class ApplicationWideMessageService {
	constructor(private db: AngularFireDatabase) {}

	public getAppWideMessage() {
		const path = fancyFirebaseGetters.getStatusMessagePath();
		const ref = masterFancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(
			path
		) as PathReference;
		return this.db.object<IApplicationWideMessage>(ref).valueChanges();
	}
}
